import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';

export const translateDocType = (kaynakBelgeTuru, tipNo = null, belgesizFis = false) => {
    switch (kaynakBelgeTuru) {
        case 'invoice':
            return 'Fatura';
        case 'check':
            return 'Çek';
        case 'order-customer':
            return 'Müşteri Sipariş Belgesi';
        case 'order-vendor':
            return 'Satıcı Sipariş Belgesi';
        case 'voucher':
            return 'Senet';
        case 'shipment':
            return 'Navlun';
        case 'receipt':
            return 'Makbuz';
        case 'other':
            return 'Diğer';
        case 'Geçersiz girdi':
            if (tipNo === 0 || tipNo === 4 || belgesizFis) {
                return '';
            }
            return '';
        default:
            return kaynakBelgeTuru;
    }
};

export const docName = (docExp, docType, tipNo = null, belgesizFis = false) => {
    if (docType === 'other' && (docExp === '' || docExp === null || docExp === undefined)) {
        if (belgesizFis) {
            return '';
        }
        return '';
    }

    switch (docExp) {
        case 'Geçersiz girdi':
            if (tipNo === 0 || tipNo === 4 || belgesizFis) {
                return '';
            }
            return '';
        default:
            return docExp;
    }
};

export const documentData = (docNo, docDate, title, docType, tipNo = null, belgesizFis = false) => {
    if ((docType === 'other' || docType === 'invoice' || docType === 'check') && (docNo === '' || docNo === null || docNo === undefined) && (docDate === '' || docDate === null || docDate === undefined)) {
        // Belgesiz fiş ise evrak boş olabilir
        if (belgesizFis) {
            return '';
        }
        return '';
    }

    if (tipNo === 0 || tipNo === 4) {
        return '';
    }

    if (docNo && !docDate) {
        if (title === 'evrak_tarihi') {
            return belgesizFis ? '' : '';
        }
        return docNo;
    } else if (!docNo && docDate) {
        if (title === 'evrak_no') {
            return belgesizFis ? '' : '';
        }
        return docDate;
    } else if (docNo && docDate) {
        return title === 'evrak_no' ? docNo : docDate;
    } else {
        return belgesizFis ? '' : '';
    }
};

export const itemNo = (itemNo) => {
    if (itemNo) {
        return itemNo;
    } else if (itemNo === '' || itemNo === null || itemNo === undefined) {
        return '0';
    }
};

export const checkAmountAndCredit = (amount, credit, title) => {
    if ((amount === '' || amount === null || amount === undefined) && (credit === '' || credit === null || credit === undefined)) {
        return <Tag severity="danger" value={'BOŞ'} />;
    } else if (amount === 0 && credit === 0) {
        return <Tag severity="danger" value={'SIFIR olamaz.'} />;
    } else {
        let amount1 = new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY'
        }).format(title === 'borc' ? amount : credit);

        return <p> {amount1} </p>;
    }
};

const controllReceiptDetails = (receiptDetails, isDocumentless = false) => {
    for (let i = 0; i < receiptDetails.length; i++) {
        // Belge türü her zaman zorunlu
        if (receiptDetails[i].belge_turu === null || receiptDetails[i].belge_turu === undefined || receiptDetails[i].belge_turu === '') {
            return false;
        }

        // Belgesiz fiş değilse evrak no ve tarihi zorunlu
        if (!isDocumentless) {
            if (
                receiptDetails[i].evrak_no === null ||
                receiptDetails[i].evrak_no === undefined ||
                receiptDetails[i].evrak_no === '' ||
                receiptDetails[i].evrak_tarihi === null ||
                receiptDetails[i].evrak_tarihi === undefined ||
                receiptDetails[i].evrak_tarihi === ''
            ) {
                return false;
            }
        }
    }

    return true;
};

export const controlAllData = (data, messages = []) => {
    const receipt = data.receipt;
    const receiptDetails = data.receipt?.receiptDetails;

    if (receipt?.receiptDetails.length < 2) {
        messages.push('Fiş detayı en az 2 satır olmalıdır.');
        return false;
    }

    if (receipt.borc !== receipt.alacak) {
        messages.push('Borç ve Alacak eşit olmalıdır.');
        return false;
    }

    if (receipt.tip_id !== 0 && receipt.tip_id !== 4) {
        // Belgesiz fiş kontrolü: HİÇBİR ZAMAN KONTROL YAPMA
        if (receipt.belgesiz_fis === 1) {
            return true; // Belgesiz fiş her zaman geçerli
        }

        // Belgeli fiş kontrolü (belgesiz_fis === 0)
        if (receipt.belgesiz_fis === 0) {
            if (!(docName(receipt.kaynak_belge_turu_aciklama, receipt.kaynak_belge_turu) === receipt.kaynak_belge_turu_aciklama)) {
                messages.push('Belge Türü hatalı.');
                return false;
            }

            // Belgeli fiş için evrak no ve tarihi zorunlu
            if (receiptDetails[0].evrak_no === '' || receiptDetails[0].evrak_tarihi === '') {
                messages.push('Belgeli fiş için evrak no ve evrak tarihi zorunludur.');
                return false;
            }

            // Tüm detail satırları kontrolü (belgeli fiş için)
            if (!controllReceiptDetails(receiptDetails, false)) {
                messages.push('Fiş detayı hatalı.');
                return false;
            }
        }
    }
    return true;
};

export const rowIsTrue = (rowData) => {
    let messages = [];
    const check = controlAllData(rowData, messages);

    if (!check) {
        return <Button severity="danger" size="large" icon="pi pi-exclamation-triangle" tooltip={messages.length > 0 ? messages.join(', ') : 'Hatalı satır'} tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }} />;
    }

    return <Button severity="success" icon="pi pi-check" tooltip="Doğru satır!" className="text-white" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }} />;
};

export const wrongRow = (rowData) => {
    return !controlAllData(rowData);
};

export const checkBorc = (rowData) => {
    let amount = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
    }).format(rowData.receipt.borc);

    return <p> {amount} </p>;
};

export const checkAlacak = (rowData) => {
    let amount = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
    }).format(rowData.receipt.alacak);

    return <p> {amount} </p>;
};
